import { useQuery } from "@tanstack/react-query";
import * as req from "@script/req.ts";

export function useWantedListQuery(groupId: string | null) {
  return useQuery({
    queryKey: ["wantedList", groupId],
    queryFn: () => req.wanted_all(groupId ?? undefined),
    staleTime: 5 * 60 * 1000,
    retry: 1,
    retryDelay: 1000,
  });
}
